// extracted by mini-css-extract-plugin
export var black = "_x-6";
export var brand = "_x-1";
export var ddefault = "_x-0";
export var error = "_x-3";
export var gray = "_x-2";
export var highContrast = "_x-8";
export var outline = "_x-7";
export var success = "_x-5";
export var warning = "_x-4";